import type { Grade } from "~/types";

type Props = {
  grade: Grade;
};

export function ItemGrade({ grade }: Props) {
  if (grade === "none" || grade === "crystal_free") return null;
  return <span className="grade">{grade}</span>;
}
